import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, Optional, ViewChild } from '@angular/core';
import { IFilterFacet, IFilterFacetItem } from '@impact/data';
import * as icons from '../../../icons';
import { FacetStateService } from '../../core/facet-state.service';
import { ExpansionPanelComponent } from '../../expansion-panel/expansion-panel.component';
import { FilterService } from '../../filter-service/filter.service';
import { COLLAPSE_PANELS } from '../../models/filter.models';

interface IShowOnlyFilter {
    label: string;
    item: IFilterFacetItem;
}

@Component({
    selector: 'app-facet-show-only',
    templateUrl: 'facet-show-only.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FacetShowOnlyComponent implements OnInit {
    @Input()
    set filters(filters: Record<string, IFilterFacet | undefined> | undefined) {
        if (!filters) {
            return;
        }

        this.facetFilters = [];

        for (const [key, value] of Object.entries(filters)) {
            const trueItem = value?.items?.find((item) => item.key === 'true');

            if (trueItem) {
                trueItem.label = key;

                this.facetFilters.push({
                    label: value?.label ?? '',
                    item: trueItem,
                });
            }
        }
    }
    facetFilters: IShowOnlyFilter[];

    @ViewChild('panel') panel: ExpansionPanelComponent;

    facetItems?: IFilterFacetItem[] | null = [];

    icons = icons;

    expandPanel = false;
    facetStateServiceLabel = 'facetStateService';

    constructor(
        public readonly filterService: FilterService,
        private readonly facetStateService: FacetStateService,
        @Optional() @Inject(COLLAPSE_PANELS) private collapsePanels: boolean
    ) {}

    ngOnInit(): void {
        const expandState = this.facetStateService.getExpandedState(this.facetStateServiceLabel);
        this.expandPanel = expandState ?? this.collapsePanels ?? true;
    }

    handleChange(filter: IShowOnlyFilter) {
        if (filter.item.label) {
            this.filterService.setFacet({ facet: filter.item.label, option: filter.item });
        }
    }

    onPanelChange(value: boolean) {
        if (value) {
            this.facetStateService.storeFacetAsExpanded(this.facetStateServiceLabel);
        } else {
            this.facetStateService.storeFacetAsColapsed(this.facetStateServiceLabel);
        }
    }
}
